const WhiteSpace = ({width,height}) =>{
    const divStyle = {
        width: `${width}px`,
        height: `${height}px`,
    };
    return(
        <div style={divStyle}></div>
    );
}

export default WhiteSpace;